module.exports = __webpack_public_path__ + "static/media/argos-pg4.aaac7bd1.jpg";